import React, { useContext, useEffect, useState } from "react"

// utility;
import * as AppConstants from "../../../../utility/AppConstants"
import * as Utility from "../../../../utility/Utility"

// componenti;
import TabTotali from "../TabTotali"
import TabGrafici from "../TabGrafici"
import { Tabs } from "@sogei/react-web-components-catalog"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"
import TabTotaliMultiAnno from "./TabTotaliMultiAnno"
import { ResponseDatiRegionaliMultiAnno } from "@/utility/model"
import axios from "axios"
//import { UserDataContext } from "@/containers/UserContext"
import { useHistory } from "react-router-dom"

interface TabRegionaliProps {
    codIsa: any
    macroarea: string | null | undefined
    datiRegionali:
        | { elementiRegionali: any[] | undefined }
        | ResponseDatiRegionaliMultiAnno[]
    anno: any
}

function TabRegionaliMultiAnno(props: TabRegionaliProps) {
    

    
    const [datiRegionali, setDatiRegionali] = useState<
        ResponseDatiRegionaliMultiAnno[]
    >([])

    //const [, setUser] = React.useContext(UserDataContext)
    let macroArea =
        props.macroarea == undefined || props.macroarea == ""
            ? "@@"
            : props.macroarea

    let codiceIsa =
        props.codIsa == undefined || props.codIsa == "" ? "@@" : props.codIsa
    useEffect(() => {
        const url = AppConstants.URL_GET_DATI_REGIONALI_MULTI_ANNO
        axios
            .get(url, {
                params: {
                    anno: props.anno,
                    codIsa: codiceIsa,
                    macroarea: macroArea
                }
            })
            .then((response) => {
                //let returnCode = response.data.returnCode
                console.log("response nostra ",response);
                if (
                    response.data.length !== undefined &&
                    response.data.length > 0
                ) {
                    
                    
                    setDatiRegionali(response.data)
                } else {
                    console.log("URL_GET_DATI_REGIONALI_MULTI_ANNO response:" + response);
                }
            })
            .catch((err) => {
                console.log("err: ", err)
            })
        return () => {}
    }, [props])

    let distinctData = [
        datiRegionali.find((e) => e.anno == props.anno),
        datiRegionali.find((e) => Number(e.anno) == Number(props.anno) + 1),
        datiRegionali.find((e) => Number(e.anno) == Number(props.anno) + 2)
    ]
    let codiciIsa = distinctData.map((e) => String(e?.codIsa))
    
    const tabAnni = [
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TITLE_NUM_POSIZIONI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabTotaliMultiAnno
                    codIsa={props.codIsa}
                    datoToVisualize={"numPosizioni"}
                    macroarea={props.macroarea}
                    anno={props.anno}
                    datiRegionali={datiRegionali}
                    codiciIsa={codiciIsa}
                />
            )
        },
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TITLE_NUM_ADDETTI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabTotaliMultiAnno
                    codIsa={props.codIsa}
                    datoToVisualize={"numAddetti"}
                    macroarea={props.macroarea}
                    anno={props.anno}
                    datiRegionali={datiRegionali}
                    codiciIsa={codiciIsa}
                />
            )
        },
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TITLE_RICAVI_COMPENSI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabTotaliMultiAnno
                    codIsa={props.codIsa}
                    datoToVisualize={"ricCompDic"}
                    macroarea={props.macroarea}
                    anno={props.anno}
                    datiRegionali={datiRegionali}
                    codiciIsa={codiciIsa}
                />
            )
        },
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TITLE_REDDITI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabTotaliMultiAnno
                    codIsa={props.codIsa}
                    datoToVisualize={"reddDic"}
                    macroarea={props.macroarea}
                    anno={props.anno}
                    datiRegionali={datiRegionali}
                    codiciIsa={codiciIsa}
                />
            )
        },
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TITLE_PUNTEGGIO_ISA}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabTotaliMultiAnno
                    codIsa={props.codIsa}
                    datoToVisualize={"punteggioIsaAnom"}
                    macroarea={props.macroarea}
                    anno={props.anno}
                    datiRegionali={datiRegionali}
                    codiciIsa={codiciIsa}
                />
            )
        },
        {/*
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TITLE_PUNTEGGIO_ISA_NO_ANOMALIE}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabTotaliMultiAnno
                    codIsa={props.codIsa}
                    datoToVisualize={"punteggioIsaNonAnom"}
                    macroarea={props.macroarea}
                    anno={props.anno}
                    datiRegionali={datiRegionali}
                    codiciIsa={codiciIsa}
                />
            )*/
        }
    ]
    const items = [
        ...tabAnni,
        {
            title: (
                <>
                    <i className="fab fa-font-awesome-flag mr-2"></i>
                    {AppConstants.TAB_GRAFICI}
                </>
            ),
            titleHeading: "h1",
            body: (
                <TabGrafici
                    codIsa={props.codIsa}
                    datiRegionali={datiRegionali}
                    macroarea={Utility.trascodificaMacroArea(props.macroarea)}
                    anno={props.anno}
                />
            )
        }
    ]

    return (
        <div className="row">
            <div className="col-12">
                <Tabs
                    items={items}
                    isReverseType={true}
                    // onShow={(e: any) => console.log(e)}
                />
            </div>
        </div>
    )
}
export default TabRegionaliMultiAnno
